import React, { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { GetStitchLetterAPI } from 'api/community';
import moment from 'moment';
import * as Styled from './style';

const StitchLetterList: React.FC = () => {
  const [letterData, setLetterData] = useState([]);

  const fetchLetterAPI = async () => {
    const data: AxiosResponse = await GetStitchLetterAPI();
    setLetterData(data.data);
  };

  const changeTimeFormat = ({
    time,
    // tz = "Asia/Seoul",
    format = 'YYYY.MM.DD',
  }: {
    time: string;
    tz?: string;
    format?: string;
  }) => {
    return moment(time).format(format);
  };

  useEffect(() => {
    fetchLetterAPI();
  }, []);

  return (
    <div className="cnts-wrap">
      <Styled.Wrapper>
        <Styled.LettersWrapper>
          <Styled.LetterHeading>
            <Styled.LetterHeadingInner>
              <img
                src="/images/letterheader.svg"
                alt="stitch letter heading img"
              />
            </Styled.LetterHeadingInner>
          </Styled.LetterHeading>
          {letterData.map((item, idx) => (
            <Styled.LetterRow
              key={item.title + idx}
              onClick={() => window.open(item.url, '_blank')}
            >
              <Styled.LetterNumber>
                Stitch Letter
                <Styled.Br /> #{item.number}
              </Styled.LetterNumber>
              <Styled.LetterContent>
                <Styled.LetterDate>
                  {changeTimeFormat({ time: item.date })}
                </Styled.LetterDate>
                <Styled.LetterTitle>{item.title}</Styled.LetterTitle>
                <Styled.LetterUl>
                  {item.content.map((x, idx) => (
                    <Styled.LetterLi key={x.content + idx}>
                      {x.content}
                    </Styled.LetterLi>
                  ))}
                </Styled.LetterUl>
              </Styled.LetterContent>
            </Styled.LetterRow>
          ))}
        </Styled.LettersWrapper>
      </Styled.Wrapper>
    </div>
  );
};

export default StitchLetterList;
